import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import "./brands.css";

const brands = [
  {
    id: 1,
    name: "Dyson",
    logo: "./images/brands/dyson.png",
    description:
      "Dyson is a global technology company specializing in innovative home appliances. Known for its powerful vacuum cleaners, air purifiers, and hair care tools, Dyson focuses on advanced engineering and cutting-edge design. The brand emphasizes performance, durability, and futuristic technology to improve everyday household experiences.",
  },
  {
    id: 2,
    name: "SONOS",
    logo: "./images/brands/sonos.png",
    description:
      "Sonos is a premium audio technology company known for its wireless home sound systems and smart speakers. The brand delivers immersive, room-filling sound with seamless multi-room connectivity. Designed for modern living, Sonos products combine minimalist aesthetics, powerful performance, and integration with popular streaming services and voice assistants.",
  },
];

const Brands = () => {
  return (
    <div>
      {/* Header component */}
      <Header />
      {/* Brands content */}
      <div className="container my-5">
        <h1 className="mb-4 text-center">Our Brands</h1>
        <p>
          We are proud to offer a wide range of products from top brands in the
          industry. Our selection includes trusted names known for their quality
          and innovation. Whether you're looking for the latest gadgets, stylish
          apparel, or home essentials, we have something for everyone. Explore
          our collection and discover the brands that make us stand out.
        </p>
      </div>

      <div className="brands-page py-5">
        <Container>
          {/* <h2 className="text-center mb-5 fw-bold section-title">
            Our Premium Brands
          </h2> */}

          {brands.map((brand, index) => (
            <motion.div
              key={brand.id}
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="brand-card mb-4 shadow-lg border-0">
                <Card.Body>
                  <Row className="align-items-center">
                    {/* Logo Section */}
                    <Col
                      lg={4}
                      md={5}
                      sm={12}
                      className="text-center mb-3 mb-md-0"
                    >
                      <motion.img
                        src={brand.logo}
                        alt={brand.name}
                        className="brand-logo img-fluid"
                        whileHover={{ scale: 1.1 }}
                        transition={{ type: "spring", stiffness: 200 }}
                      />
                    </Col>

                    {/* Details Section */}
                    <Col lg={8} md={7} sm={12}>
                      <h3 className="fw-bold">{brand.name}</h3>
                      <p className="text-muted">{brand.description}</p>
                      <NavLink to={`/shop?brand=${brand.name}`}>
                        <Button className="buy-btn mt-3">Buy Now</Button>
                      </NavLink>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </motion.div>
          ))}
        </Container>
      </div>
      {/* Footer component */}
      <Footer />
    </div>
  );
};

export default Brands;
